/**
 * HomePageStatic is not the same with HomePageV1 or HomePageV2.
 * A static page is data-driven.
 *
 * @summary short description for the file
 * @author MonkeyFigaro <monkeychen@sohu-inc.com>
 *
 * Created at     : 2019-08-13 17:36:35
 * Last modified  : 2019-10-12 15:45:39
 */
import React from 'react';
import { HomeDataStore } from '../../models/stores/HomeDataStore';
import s from './HomePage.scss';
import { HomeSearchBox } from '../HomePageV2/components/HomeSearchBox';
import { NewsCard } from '../../components/HomeTop/NewsCard';
import { CategoryCard } from '../../components/HomeTop/CategoryCard';
import { SliderCard } from '../../components/HomeTop/SliderCard';
import { BeauPic } from '../../components/HomeTop/BeauPic';
import { ReportBanner } from '../../components/ReportBanner';
import { GodBox, SliderAds, PureTextAdBanner } from '../../components/AdGod';
import { HotCardComment } from '../../components/HomeTop/HotCard';
import { RegionKeys } from '../../models/regionDict';
import { WebsiteMap } from '../HomePageV2/components/WebsiteMap';
import { CommonFooter } from '../../components/CommonFooter';
import { PoliticsFooter } from '../../components/PoliticsFooter';
import { ClassicHomeNav } from '../../components/ClassicHomeNav';
import { SingleScreen } from '../../components/SingleScreen';
import { SubjectPlaceHolder } from '../../components/SubjectPlaceHolder';
import { FeedInstance, isFeedInstance } from '../../models/feed';
import { PromotionInstance } from '../../models/apis/promotion';
import { UserReport } from '../../components/UserReport';
import { VideoCard } from '../..//components/HomeTop/VideoCard';

const initStore: HomeDataStore = {
    batchDataStore: {},
    feedApiStore: {},
    hotSearchStore: [],
    homeDataStore: {
        home: {
            topNews: {
                cpcNews: [],
                news: [],
                newsFeed: [],
            },
        },
        news: {
            osData: {
                hotVideo: [],
                hotVideoFeed: [],
            },
        },
    },
};

export const HomePageStatic = (props: { store?: HomeDataStore }) => {
    const { store = initStore } = props;
    const getBatch = (reqId: RegionKeys) => {
        let result: Array<FeedInstance | PromotionInstance> = [];
        if (store.batchDataStore[reqId]) {
            result = store.batchDataStore[reqId]!.data;
        }
        return result || [];
    };
    const getBatchFeed = (reqId: RegionKeys): FeedInstance[] => {
        const tmp = getBatch(reqId);
        const res: FeedInstance[] = [];
        tmp.forEach(e => { if (isFeedInstance(e)) { res.push(e); }});
        return res;
    };
    const getFeeds = (reqId: number, size = 10) => {
        if (store.feedApiStore[reqId]) {
            return store.feedApiStore[reqId].slice(0, size);
        }
        return [];
    };
    const hotwords = store.hotSearchStore.slice(0, 8);
    const miscellaneous = [store.hotSearchStore.slice(8, 38), store.hotSearchStore.slice(38, 68)];
    return (
        <div className={s.container}>
            <ClassicHomeNav />
            <div className={s.layer}>
                <HomeSearchBox hotSearch={hotwords} />
                <div className={s.row}>
                    <div className={s.leftBox}>
                        <div className={s.section}>
                            <NewsCard topNews={store.homeDataStore.home.topNews} />
                        </div>
                        <div className={s.section}>
                            <div className={s.headerBg}>
                                <img className={s.img} src="http://statics.itc.cn/sohu-homepage/classicentrance.png"/>
                            </div>
                            <div className={s.alert}>
                                <img src="http://statics.itc.cn/sohu-homepage/classicalert.png" />
                            </div>
                            <CategoryCard title='深读' size={10} target='' spmCode={{ content: 'top-choice' }} source={getBatch(11675)} type="own" />
                            <VideoCard source={getBatchFeed(14257)} />
                            <SliderCard dataSource={getBatch(12579)} />
                        </div>
                    </div>
                    <div className={s.rightBox}>
                        <ReportBanner />
                        <GodBox width={300} height={250} dataSource={getBatch(12675)} spmCode="god-side-1">
                            <SubjectPlaceHolder source={getBatch(13697)} title="科学观察" slogan="从粒子到宇宙，了解科学之美。" bgImage="//statics.itc.cn/PC_classichome/kxgc.png" page="https://www.sohu.com/column/10583"/>
                        </GodBox>
                        <HotCardComment title="热评" dataSource={store.feedApiStore[11745] || []} />
                        <SliderAds dataSource={getBatch(12744)} placeholderConfigs={[
                            { source: getBatch(13699), title: '股市热搜榜', slogan: '紧抓热点板块 洞悉市场风向', bgImage: '//statics.itc.cn/PC_classichome/gsrsb.png', page:'https://www.sohu.com/column/10580' },
                            { source: getBatch(13700), title: '影视研读社', slogan: '看片追剧神器，最全明星八卦', bgImage: '//statics.itc.cn/PC_classichome/ysyds.png', page:'https://www.sohu.com/column/10629' },
                            { source: getBatch(13701), title: '开心一刻', slogan: '捧腹一乐 欢心一天', bgImage: '//statics.itc.cn/PC_classichome/kxyk.png', page:'https://www.sohu.com/column/10579' },
                            { source: getBatch(13702), title: '生肖财运', slogan: '这一年出生的人财运来了！', bgImage: '//statics.itc.cn/PC_classichome/sxcy.png', page:'https://www.sohu.com/column/10582' },
                        ]} />
                    </div>
                </div>
                <div>
                    <GodBox width={1180} height={100} dataSource={getBatch(12676)} spmCode="god-middle-1" />
                    <PureTextAdBanner dataSources={[getBatch(12677), getBatch(12752), getBatch(12753)]} miscellaneous={miscellaneous[0]} spmCode="god-middle-text1" />
                </div>
                <SingleScreen
                    channelConfigs={[
                        { type: "category", title: '体育', size: 4, target: 'http://sports.sohu.com', placeholder: 'sports', spmCode: { title: 'sports-nav', content: 'sports-news1' }, source: getBatch(13453).concat(...getBatch(11586)) },
                        { type: "category", title: '娱乐', size: 4, target: 'http://yule.sohu.com', placeholder: 'yule', spmCode: { title: 'yule-nav', content: 'yule-news1' }, source: getBatch(13455).concat(...getBatch(11588)) },
                        { type: "category", title: '财经', size: 4, target: 'http://business.sohu.com', placeholder: 'business', spmCode: { title: 'business-nav', content: 'business-news1' }, source: getBatch(13454).concat(...getBatch(11581)) },
                        { type: "category", title: '军事', size: 4, target: 'http://mil.sohu.com', placeholder: 'mil', spmCode: { title: 'mil-nav', content: 'mil-news1' }, source: getBatch(11609) },
                    ]}
                    enumConfigs={[
                        { titles: ['NBA', 'CBA', '中超'], source: [getFeeds(11750, 2), getFeeds(11752, 2), getFeeds(11753, 2)], spm: 'sports' },
                        { titles: ['明星', '影视', '综艺'], source: [getBatch(11589), getBatch(11590), getBatch(11591)], spm: 'yule' },
                        { titles: ['楼市', '股市', '民生'], source: [getBatch(11582), getBatch(11583), getBatch(11584)], spm: 'business' },
                        { titles: ['武器', '环球', '战争史'], source: [getBatch(11610), getBatch(11611), getBatch(11612)], spm: 'mil' },
                    ]}
                    recommendConfigs={[
                        { spm: "global", title: '国际', source: getBatch(11629), size: 2 },
                        { spm: "legend", title: '故事', source: getBatch(11630), size: 2 },
                        { spm: "science", title: '科普', source: getBatch(11631), size: 2 },
                        { spm: "points", title: '观点', source: getBatch(11632), size: 2 },
                    ]}
                    rectAdConfig={[
                        { width: 300, height: 250, spmCode: 'god-side-3', dataSource: getBatch(12745), children: (<SubjectPlaceHolder source={getBatch(13703)} title="吃点好的" slogan="行万里路，食八方味" bgImage="//statics.itc.cn/PC_classichome/cdhd.png" page="https://www.sohu.com/column/10578" />) },
                    ]}
                />
                <div className={s.beauPicWrap}>
                    <h3 className={s.hTitle}>美图</h3>
                    <BeauPic dataSources={[getBatch(11575), getBatch(11574), getBatch(11572), getBatch(11573)]} spms={['pics-yule', 'pics-fashion', 'pics-travel', 'pics-food']} />
                </div>
                <div>
                    <GodBox width={1180} height={100} dataSource={getBatch(12748)} spmCode="god-middle-2" />
                </div>
                <div id="fe-root">
                    <SingleScreen
                        channelConfigs={[
                            { type: 'category', title: '汽车', size: 4, target: 'http://auto.sohu.com/', placeholder: 'auto', spmCode: { title: 'auto-nav', content: 'auto-news1' }, source: getBatch(11596) },
                            { type: 'category', title: '科技', size: 4, target: 'http://it.sohu.com/', placeholder: 'tech', spmCode: { title: 'tech-nav', content: 'tech-news1' }, source: getBatch(11605).concat(...getBatch(13456)) },
                            { type: 'category', title: '房产', size: 4, target: 'https://house.focus.cn/', placeholder: 'focus', spmCode: { title: 'focus-nav', content: 'focus-news1' }, source: getBatch(13676) },
                            { type: 'category', title: '健康', size: 4, target: 'http://health.sohu.com/', placeholder: 'health', spmCode: { title: 'health-nav', content: 'health-news1' }, source: getBatch(11592).concat(...getBatch(13457)) },
                        ]}
                        enumConfigs={[
                            { titles: ['买车', '用车', '车视频'], source: [getBatch(11597), getBatch(11598), getBatch(11599)], spm: 'auto' },
                            { titles: ['互联网', '通讯', '科学'], source: [getBatch(11606), getBatch(11607), getBatch(11608)], spm: 'tech' },
                            { titles: ['家居', '二手房'], source: [getBatch(13677), getBatch(13678)], spm: 'focus' },
                            { titles: ['养生', '医疗', '两性健康'], source: [getBatch(11593), getBatch(11594), getBatch(11595)], spm: 'health' },
                        ]}
                        recommendConfigs={[
                            { source: getBatch(11633), size: 2, title: '情感', spm: 'emotion' },
                            { source: getBatch(11634), size: 2, title: '运势', spm: 'fate' },
                            { source: getBatch(11635), size: 2, title: '测评', spm: 'assessment' },
                            { source: getBatch(11636), size: 2, title: '揭秘', spm: 'secrets' },
                        ]}
                        rectAdConfig={[
                            { width: 300, height: 250, spmCode: 'god-side-4', dataSource: getBatch(12746), children: (<SubjectPlaceHolder source={getBatch(13704)} title="美妆种草" slogan="种草达人 精选推荐" bgImage="//statics.itc.cn/PC_classichome/mzzc.png" page="https://www.sohu.com/column/10571" />) },
                        ]}
                        longAdConfig={[
                            { width: 1180, height: 100, spmCode: 'god-middle-3', dataSource: getBatch(12749) },
                        ]}
                    />
                    <SingleScreen
                        channelConfigs={[
                            { type: 'category', title: '时尚', size: 4, target: 'http://fashion.sohu.com/', placeholder: 'fashion', spmCode: { title: 'fashion-nav', content: 'fashion-news1' }, source: getBatch(11613).concat(...getBatch(13458)) },
                            { type: 'category', title: '文化', size: 4, target: 'http://cul.sohu.com/', placeholder: 'cul', spmCode: { title: 'cul-nav', content: 'cul-news1' }, source: getBatch(11621).concat(...getBatch(13460)) },
                            { type: 'category', title: '教育', size: 4, target: 'http://learning.sohu.com/', placeholder: 'learning', spmCode: { title: 'learning-nav', content: 'learning-news1' }, source: getBatch(11617).concat(...getBatch(13459)) },
                            { type: 'category', title: '旅游', size: 4, target: 'http://travel.sohu.com/', placeholder: 'travel', spmCode: { title: 'travel-nav', content: 'travel-news1' }, source: getBatch(11625) },
                        ]}
                        enumConfigs={[
                            { titles: ['时装', '美容', '男士'], source: [getBatch(11614), getBatch(11615), getBatch(11616)], spm: 'fashion' },
                            { titles: ['人物', '读书', '艺术'], source: [getBatch(11622), getBatch(11623), getBatch(11624)], spm: 'cul' },// learning
                            { titles: ['中小学', '高考', '校园'], source: [getBatch(11618), getBatch(11619), getBatch(11620)], spm: 'learning' },// cul
                            { titles: ['国内游', '境外游', '攻略'], source: [getBatch(11626), getBatch(11627), getBatch(11628)], spm: 'travel' },
                        ]}
                        recommendConfigs={[
                            { source: getBatch(11637), size: 2, title: '美食', spm: 'food' },
                            { source: getBatch(11638), size: 2, title: '育儿', spm: 'baby' },
                            { source: getBatch(11639), size: 2, title: '教程', spm: 'course' },
                            { source: getBatch(11640), size: 2, title: '摄影', spm: 'photography' },
                        ]}
                        rectAdConfig={[
                            { width: 300, height: 250, spmCode: 'god-side-5', dataSource: getBatch(12747), children: (<SubjectPlaceHolder source={getBatch(13705)} title="职场新鲜事" slogan="职场见闻 一网打尽" bgImage="//statics.itc.cn/PC_classichome/zcxxs.png" page="https://www.sohu.com/column/10572" />) },
                        ]}
                    />
                </div>
                <div className={s.beauPicWrap}>
                    <h3 className={s.hTitle}>博览</h3>
                    <BeauPic dataSources={[getBatch(12575), getBatch(12576), getBatch(12574), getBatch(12577)]} spms={['expo-mil', 'expo-sports', 'expo-auto', 'expo-history']} />
                </div>
                <div>
                    <PureTextAdBanner dataSources={[getBatch(12754), getBatch(12755), getBatch(12756)]} miscellaneous={miscellaneous[1]} spmCode="god-middle-text2" />
                    <GodBox width={1180} height={100} dataSource={getBatch(12750)} spmCode="god-middle-4" />
                </div>
                <WebsiteMap />
                <div>
                    <GodBox width={1180} height={100} dataSource={getBatch(12751)} spmCode="god-middle-5" />
                </div>
                <UserReport />
                <PoliticsFooter />
                <CommonFooter />
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/pages/HomePageStatic/index.tsx